module.exports = __webpack_public_path__ + "static/media/step-indicator-3.0537d7b6.svg";